import { message } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import {
  getSysParam,
  changeSysParam,
  getRule,
  changeRule,
  getLevel,
} from '@pages/SysParamMgr/services/sysParam';

export default {
  namespace: 'sysParam',

  state: {
    data: [],
    rule: {},
    editingKey: '',
    selectedRowKey: '',
  },

  effects: {
    *fetch(_, { call, put }) {
      const { success, data } = yield call(getSysParam);

      if (success) {
        yield put({
          type: 'saveSysParam',
          payload: data,
        });
      }
    },

    *changeSysParam({ payload }, { select, call, put }) {
      const payloadN = payload;
      const params = yield select(state => state.sysParam);
      const row = params.data.find(item => payloadN.paramName === item.paramName);
      payloadN.param = row.param;
      payloadN.mask = row.mask;
      const { success, data } = yield call(changeSysParam, payloadN, 'PUT');
      if (success && data === 'success') {
        // message.success(formatMessage({ id: 'DIRMENUMGR_MOD_DIR_SUCCESS' }));
        message.success(i18n('COMMON_SUCCESS'));
        const param = yield select(state => state.sysParam);
        const newParam = [...param.data];

        const index = newParam.findIndex(item => payloadN.paramName === item.paramName);
        if (index > -1) {
          const item = newParam[index];
          newParam.splice(index, 1, {
            ...item,
            ...payloadN,
          });
          yield put({
            type: 'saveSysParam',
            payload: newParam,
          });
          yield put({
            type: 'updateEditingKey',
            payload: { editingKey: '' },
          });
        }
      }
    },

    *changeEditingKey({ payload }, { put }) {
      yield put({ type: 'updateEditingKey', payload });
    },
    *changeSelectedKey({ payload }, { put }) {
      yield put({ type: 'updateSelectKey', payload });
    },
    *fetchRule({ payload }, { call, put }) {
      const { success, data } = yield call(getRule, payload);
      if (success) {
        yield put({
          type: 'saveRule',
          payload: data,
        });
      }
    },
    *changeRule({ payload }, { call, put }) {
      const { rule } = payload;
      const { success, data } = yield call(changeRule, rule, 'PUT');
      if (success && data === 'success') {
        message.success(i18n('COMMON_SUCCESS'));
        yield put({
          type: 'saveRule',
          payload: rule,
        });
      }
    },
    *fetchLevel({ payload }, { call, put }) {
      const { success, data } = yield call(getLevel, payload);
      if (success) {
        yield put({
          type: 'fetchRule',
          payload: { level: data },
        });
      }
    },
    *clear({ payload }, { put }) {
      yield put({ type: 'clearState', payload });
    },
  },

  reducers: {
    saveSysParam(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },

    saveRule(state, { payload }) {
      return {
        ...state,
        rule: payload,
      };
    },

    updateSysParam(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },

    updateEditingKey(state, { payload }) {
      return {
        ...state,
        editingKey: payload.editingKey,
      };
    },
    updateSelectKey(state, { payload: data }) {
      return { ...state, selectedRowKey: data.selectedRowKey };
    },

    clearState(
      state,
      {
        payload: { key },
      }
    ) {
      switch (key) {
        case 'rule':
          return { ...state, rule: {} };
        default:
          return state;
      }
    },
  },
};
